import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface AdvancementStudent {
  studentGrade: SystemCode
  studentClass: SystemCode
  studentNumber: string
  userId: string
  userType: SystemCode
  status: SystemCode
  name: string
  nameKana: string
  birthday: string
  gender: SystemCode
  newStudentGrade: SystemCode // ファイル読み取りによる検索の時返却
  newStudentClass: SystemCode // ファイル読み取りによる検索の時返却
  newStudentNumber: string // ファイル読み取りによる検索の時返却
}

export function AdvancementStudentFromJSON(json: any): AdvancementStudent {
  return {
    studentGrade: exists(json, 'student_grade')
      ? SystemCodeFromJSON(json.student_grade)
      : defaultSystemCode(),
    studentClass: exists(json, 'student_class')
      ? SystemCodeFromJSON(json.student_class)
      : defaultSystemCode(),
    studentNumber: exists(json, 'student_number') ? json.student_number : '',
    userId: exists(json, 'user_id') ? json.user_id : '',
    userType: exists(json, 'user_type')
      ? SystemCodeFromJSON(json.user_type)
      : defaultSystemCode(),
    status: exists(json, 'status')
      ? SystemCodeFromJSON(json.status)
      : defaultSystemCode(),
    name: exists(json, 'name') ? json.name : '',
    nameKana: exists(json, 'name_kana') ? json.name_kana : '',
    birthday: exists(json, 'birthday') ? dateToPlainFormat(json.birthday) : '',
    gender: exists(json, 'gender')
      ? SystemCodeFromJSON(json.gender)
      : defaultSystemCode(),
    newStudentGrade: exists(json, 'new_student_grade')
      ? SystemCodeFromJSON(json.new_student_grade)
      : defaultSystemCode(),
    newStudentClass: exists(json, 'new_student_class')
      ? SystemCodeFromJSON(json.new_student_class)
      : defaultSystemCode(),
    newStudentNumber: exists(json, 'new_student_number')
      ? json.new_student_number
      : ''
  }
}
